<template>
  <HeaderComponent 
    logo-src="@/assets/securiumxlogo.85945667.png"
    title="Cyber Knight 2.0"
    subtitle="Cybersecurity Championship"
  />

  <div class="register-page">

    <!-- LEFT PANEL -->
    <div class="left-panel">

      <div class="logo-container">
        <img src="@/assets/securiumxlogo.png" alt="SecuriumX" class="logo" />
        <h2 class="brand-title">Cyber Knight 2.0</h2>
      </div>

      <!-- Prize Details -->
      <div class="prize-cards">
        <div class="prize-card paid">
          <h3>🏆 Prize Details</h3>
          <ul>
            <li>Winner – ₹35,000</li>
            <li>Runner Up – ₹25,000</li>
            <li>Second Runner Up – ₹15,000</li>
            <li>4th – 10th Place – ₹1,000</li>
            <li>Registration Fee – ₹450 per individual</li>
          </ul>
        </div>
      </div>

      <!-- Event Overview -->
      <div class="event-info">
        <p>
          Cyber Knight 2.0 is a cybersecurity-focused championship hosted at Galgotias University.
          It combines hands-on competitions, interactive workshops, and expert-led sessions.
        </p>
        <ul>
          <li>Ethical Hacking & Digital Security</li>
          <li>Real-world Cyber Threat Exposure</li>
          <li>Practical Defense & Offensive Skills</li>
          <li>Industry-Level Learning Experience</li>
        </ul>
      </div>

      <!-- Challenges -->
      

      <!-- Location -->
      
      

      <p class="footer">© 2026 Cyber Knight | All Rights Reserved</p>
    </div>


    <!-- RIGHT PANEL -->
    <div class="right-panel">

      <h1 class="register-heading">Cyber Knight 2.0 Registration</h1>

      <div class="event-info">
        <p><strong>Date:</strong> 14 Feb 2026 – 16 Feb 2026</p>
        <p><strong>Venue:</strong> Galgotias University</p>
        <p><strong>Registration Fee:</strong> ₹450</p>
      </div>

      <form @submit.prevent="startPayment" class="register-form" autocomplete="off">

        <div class="form-group" v-for="field in fields" :key="field.id">
          <label :for="field.id">{{ field.label }}</label>

          <input
            v-if="field.type !== 'file'"
            :type="field.type"
            :id="field.id"
            v-model="form[field.model]"
            :required="field.required"
          />

          <input v-else type="file" :id="field.id" @change="handleFileUpload" />
        </div>

        <button type="submit" class="pay-btn full-width">
          Register & Pay ₹450
        </button>

      </form>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { reactive } from "vue";
import HeaderComponent from "@/components/Header.vue";

export default {
  name: "CyberKnightRegister",
  components: { HeaderComponent },

  setup() {
    const form = reactive({
      first_name: "",
      last_name: "",
      username: "",
      email: "",
      phone: "",
      password: "",
      address: "",
      document: null,
    });

    const fields = [
      { id: "first_name", label: "First Name", type: "text", model: "first_name", required: true },
      { id: "last_name", label: "Last Name", type: "text", model: "last_name", required: true },
      { id: "username", label: "User Name", type: "text", model: "username", required: true },
      { id: "email", label: "Email", type: "email", model: "email", required: true },
      { id: "phone", label: "Phone", type: "tel", model: "phone", required: true },
      { id: "password", label: "Password", type: "password", model: "password", required: true },
      { id: "address", label: "Address", type: "text", model: "address" },
      { id: "document", label: "Upload College ID", type: "file", model: "document" },
    ];

    return { form, fields };
  },

  data() {
    return {
      apiBaseUrl: "https://central-auth-backend.onrender.com/api",
    };
  },

  methods: {

    handleFileUpload(e) {
      this.form.document = e.target.files[0];
    },

    async startPayment() {
      try {
        const orderRes = await axios.post(`${this.apiBaseUrl}/payment/order`, {
          amount: 450,
          productId: "cyber_knight_ticket",
          currency: "INR",
        });

        const { order, key } = orderRes.data;

        const options = {
          key,
          amount: 450 * 100,
          currency: "INR",
          name: "Cyber Knight 2.0",
          description: "Cyber Knight Registration",
          order_id: order.id,

          handler: async (resp) => {
            await axios.post(`${this.apiBaseUrl}/payment/verify`, resp);

            const formData = new FormData();
            Object.keys(this.form).forEach(k =>
              formData.append(k, this.form[k] ?? "")
            );

            formData.append("event_name", "Cyber Knight 2.0");
            formData.append("amount", 450);

            const regRes = await axios.post(
              `${this.apiBaseUrl}/registration/send-confirmation`,
              formData
            );

            alert(`✅ Registration Successful! Reg No: ${regRes.data.registration_no}`);
            window.location.href = "https://register.securiumx.com/register/thankyou";
          },

          prefill: {
            name: this.form.first_name + " " + this.form.last_name,
            email: this.form.email,
            contact: this.form.phone,
          },

          theme: { color: "#e50914" },
        };

        new window.Razorpay(options).open();

      } catch (err) {
        alert("Payment Failed ❌");
        console.error(err);
      }
    },
  },

  mounted() {
    if (!window.Razorpay) {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      document.body.appendChild(script);
    }
  },
};
</script>

<!-- ⚠️ IMPORTANT -->
<!-- KEEP YOUR EXISTING STYLE BLOCK SAME -->
<!-- NO CSS CHANGES REQUIRED -->

<style scoped>
/* --- Reset + Layout --- */
html, body { margin: 0; padding: 0; width: 100%; height: 100%; overflow-x: hidden; font-family: 'Poppins', sans-serif; }
* { box-sizing: border-box; }

.register-page {
  display: flex;
  min-height: 100vh;
  background: #0a0a0a;
  color: #fff;
  flex-wrap: wrap;
  position: relative;
}
.register-page::before {
  content: '';
  position: absolute; inset: 0;
  background: url('https://images.unsplash.com/photo-1599308698114-14227926b485?auto=format&fit=crop&q=80&w=2670') no-repeat center/cover;
  opacity: 0.08;
  z-index: -1;
  animation: bg-pan 30s linear infinite alternate;
}
@keyframes bg-pan { 0%{transform:scale(1);} 100%{transform:scale(1.1);} }

.left-panel {
  flex: 1 1 40%;
  min-width: 300px;
  background: linear-gradient(135deg, #0a0a0a, #1a0000, #330000);
  padding: 40px 20px;
  display: flex; flex-direction: column; justify-content: space-between;
}
.logo { width: 120px; border-radius: 12px; filter: drop-shadow(0 0 10px #e50914); }
.brand-title { font-size: 28px; margin-top: 10px; }
.event-info { margin: 30px 0; }
.event-info p, .event-info ul { font-size: 15px; text-align: left;  line-height: 1.6; color: #f0cfcf; }

/* === Prize Cards === */
.prize-cards {
  display: flex;
  gap: 20px;
  margin: 20px 0 30px 0;
  flex-wrap: wrap;
}
.prize-card {
  position: relative;
  flex: 1;
  min-width: 200px;
  padding: 20px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(229, 9, 20, 0.3);
  box-shadow: 0 8px 20px rgba(229, 9, 20, 0.2);
  transition: all 0.4s ease-in-out;
  text-align: center;
  overflow: hidden;
}
.prize-card h3 {
  margin-bottom: 15px;
  font-size: 20px;
  color: #fff;
  text-shadow: 0 0 5px #e50914;
}
.prize-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
  color: #ffb3b3;
  font-size: 14px;
  line-height: 1.6;
}
.prize-card:hover {
  background: linear-gradient(135deg, rgba(20,0,0,0.8), rgba(229,9,20,0.6));
  box-shadow: 0 0 25px rgba(229, 9, 20, 0.8);
  transform: translateY(-5px);
}
.prize-card:hover::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(
    120deg,
    rgba(255, 255, 255, 0.2),
    transparent,
    rgba(255, 255, 255, 0.1)
  );
  animation: shine 1.5s linear infinite;
  pointer-events: none;
}
@keyframes shine {
  from { transform: translateX(-100%); }
  to { transform: translateX(100%); }
}

/* Winners */
.winners-cards { display: flex; flex-wrap: wrap; gap: 15px; margin-top: 15px; }
.winner-card { background: rgba(255,255,255,0.05); padding: 12px; border-radius: 10px; flex: 1 1 120px; text-align: center; }
.winner-card img { width: 60px; border-radius: 50%; margin-bottom: 8px; }

.right-panel {
  flex: 1 1 60%;
  min-width: 300px;
  padding: 40px 20px;
  background: rgba(20,0,0,0.85);
  border-left: 2px solid #e50914;
  display: flex; flex-direction: column; align-items: center;
}
.register-heading { font-size: 32px; margin-bottom: 8px; text-align: center; }
.subtitle { font-size: 16px; color: #ff8080; margin-bottom: 25px; }

.register-form {
  display: grid; grid-template-columns: 1fr 1fr;
  gap: 20px 25px; width: 100%; max-width: 700px;
}
.form-group { display: flex; flex-direction: column; }
.form-group.full-width { grid-column: 1 / -1; }
.form-group input {
  padding: 12px; border-radius: 8px;
  border: 1px solid #661111;
  background: rgba(20,0,0,0.8);
  color: #ffb3b3;
}
.form-group input:focus { border-color: #e50914; outline: none; }

.coupon-input { display: flex; flex-wrap: wrap; gap: 10px; }
.coupon-section button { padding: 8px 14px; border-radius: 6px; background:#e50914; color:#fff; cursor:pointer; }

.payment-info { background: rgba(255,255,255,0.05); padding: 15px; border-radius: 8px; font-size: 15px; }
.pay-btn { background: linear-gradient(90deg, #e50914, #ff3333); padding: 14px; border-radius: 10px; color:#fff; font-size:16px; font-weight: bold; cursor:pointer; }

.registration-options { display: flex; gap: 15px; }
.registration-options label {
  padding: 10px 20px;
  border: 2px solid #661111;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255,255,255,0.05);
  color: #ffb3b3;
  font-weight: 500;
}
.registration-options label:hover {
  background: rgba(229,9,20,0.1);
  border-color: #e50914;
}
.registration-options label.active {
  background: #e50914;
  color: #fff;
  border-color: #ff3333;
}
.registration-options label input { display: none; }

@media (max-width: 768px) {
  .register-page { flex-direction: column; }
  .left-panel, .right-panel { flex: 1 1 100%; border-left: none; }
  .register-form { grid-template-columns: 1fr; }
}
/* Prize Cards Update */
.prize-cards {
  display: flex;
  gap: 20px;
  margin: 20px 0 30px 0;
  flex-wrap: wrap;
  justify-content: center;
}

.prize-card {
  position: relative;
  flex: 1;
  min-width: 250px;
  max-width: 300px;
  padding: 20px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(229, 9, 20, 0.3);
  box-shadow: 0 8px 20px rgba(229, 9, 20, 0.2);
  transition: all 0.4s ease-in-out;
  text-align: left; /* 👈 content left aligned */
}

.prize-card h3 {
  margin-bottom: 15px;
  font-size: 20px;
  color: #fff;
  text-shadow: 0 0 5px #e50914;
  text-align: center;
}

/* UL style update */
.prize-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.prize-card ul li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  font-size: 15px;
  color: #ffb3b3;
  position: relative;
  border-bottom: 1px dashed rgba(229, 9, 20, 0.3); /* 👈 divider between items */
}

/* Arrow style before each li */
.prize-card ul li::before {
  content: "➜"; /* arrow */
  color: #e50914;
  font-weight: bold;
  margin-right: 6px;
}

/* Last item no border */
.prize-card ul li:last-child {
  border-bottom: none;
}

</style>
